import VariantPricingTable from "./VariantPricingTable";

export default VariantPricingTable;